import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: "AIzaSyCVB-8zgvakDHFcP6CaQdZKZBVhgphVE5Y",  
  version: "weekly",
  libraries: ["places"],  
});

export default loader;